import get from 'lodash/get'

export default {
	setProviders (state, payload) {
		this._vm.$set(state, 'providers', payload)
	},
	setIntegrations (state, payload) {
		this._vm.$set(state, 'integrations', payload)
	},
	setSiteSettings (state, payload) {
		this._vm.$set(state, 'siteSettings', payload)
	},
	updateSiteSettings (state, payload) {
		const { siteSettings } = state
		const settings = {}

		// Update existing...
		Object.keys(siteSettings).forEach(s => {
			settings[s] = get(payload, s, siteSettings[s])
		})
		// Add new...
		Object.keys(payload).forEach(s => {
			settings[s] = payload[s]
		})

		this._vm.$set(state, 'siteSettings', settings)
	},
	updateMiscSettings (state, payload) {
		this._vm.$set(state, 'miscSettings', payload)
	},
	setAnalyticsAccounts (state, payload) {
		this._vm.$set(state, 'analyticsAccounts', payload)
	},
	setAnalyticsProfiles (state, payload) {
		this._vm.$set(state, 'analyticsProfiles', payload)
	},
}
